import { PulseBroadcaster } from "../../../../utils/pulse/types";

export const getBroadcasterKey = (broadcaster: PulseBroadcaster): string => {
  return `${broadcaster.abbreviation}|${broadcaster.name}|${broadcaster.link}`;
};
